// https://vuex.vuejs.org/ja/guide/getters.html

import { Logger } from 'aws-amplify';

const logger = new Logger('getters');

const Getters = {
  /**
   * 画面タイトル
   * @param state
   * @returns {string}
   */
  pageTitle: state => {
    return state.pageTitle;
  },

  /**
   * 最初にアクセスされたルート
   * @param state
   */
  initialRoute: state => {
    return state.initialRoute;
  },

  /**
   * ログインしているか
   * @param state
   * @returns {boolean}
   */
  loggedIn: state => {
    return !!state.auth;
  },

  /**
   * おしらせ一覧
   * @param state
   * @returns {[]}
   */
  notifications: state => {
    return state.notifications;
  },

  /**
   * id指定しておしらせ取得
   * @param state
   * @returns {function(*=): *}
   */
  notificationById: (state) => (id) => {
    logger.info(
        'notificationById', id, state.notifications.first(x => x.id === id));
    return state.notifications.first(x => x.id === id);
  },

  /**
   * 申請書・マニュアルのファイル一覧
   * @param state
   */
  manualFiles: state => {
    return state.files.manual;
  },

  /**
   * UI UXのファイル一覧
   * @param state
   */
  uiUxFiles: state => {
    return state.files.uiUx;
  },

  /**
   * 制度・福利厚生一覧
   * @param state
   * @returns {[]}
   */
  welfares: state => {
    return state.welfares;
  },

  /**
   * 制度・福利厚生一覧
   * @param state
   * @returns {[]}
   */
  getWelfares: state => {
    return state.welfares;
  },

  /**
   * id指定して制度・福利厚生取得
   * @param state
   * @returns {function(*=): *}
   */
  welfareById: (state) => (id) => {
    logger.info(
        'welfareById', id, state.welfares.first(x => x.id === id));
    return state.welfares.first(x => x.id === id);
  },
};
export default Getters;
